





































































































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import InvestmentAccountTypeSlots from "@/shared/components/investments/drivewealth/InvestmentAccountTypeSlots.vue";
import * as RouteNames from "@/employee/route-names";
import { Location } from "vue-router";

import { AdvisoryFund } from "@/shared/types";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useUserStore } from "@/shared/store/user";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

const SubPageList = "list";
const SubPageManaged = "managed";
const SubPageSelectList = "select-list";

@Component({
  components: {
    AccountTypeSubheader,
    InvestmentAccountTypeSlots,
    InstrumentName,
    GenericLoadingSpinner
  }
})
export default class DrivewealthLearnMorePages extends Vue {
  funds: AdvisoryFund[] = [];

  @Prop({ required: true })
  isOnboarding: boolean;

  @Prop({ required: false })
  accountId: number;

  userStore = useUserStore();
  portalCustomizationStore = usePortalCustomizationStore();
  drivewealthStore = useDrivewealthStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();
  custodianSettingsStore = useCustodianSettingsStore();


  mounted () {
    this.riskToleranceQuestionnaireStore.getUserRtqEligibilityResponse();
    this.drivewealthStore.loadAdvisoryFunds({ username: null, partnerId: this.portalCustomizationStore.partnerId });
    this.drivewealthStore.loadCuratedRtqFunds({ username: null, partnerId: this.portalCustomizationStore.partnerId });
    this.drivewealthStore.loadManagedFunds({ username: null, partnerId: this.portalCustomizationStore.partnerId });
  }

  get routeName () {
    return this.isOnboarding ? RouteNames.DrivewealthLearnMoreOnboarding : RouteNames.DrivewealthLearnMorePages;
  }

  get isLoaded () {
    return this.portalCustomizationStore.isSupportInfoLoaded
      && this.drivewealthStore.advisoryFundsLoaded
      && this.drivewealthStore.curatedRtqFundsLoaded
      && this.riskToleranceQuestionnaireStore.isRtqEligibilityLoaded
      && this.drivewealthStore.managedFundsLoaded;
  }

  get supportPhoneFormatted (): string {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get showLearnMoreListing () {
    return this.$route.params.subpage === SubPageList;
  }

  get showLearnMoreManaged () {
    return this.$route.params.subpage === SubPageManaged;
  }

  get toLearnMoreManaged (): Location {
    return {
      name: this.routeName,
      params: {
        subpage: SubPageManaged
      }
    };
  }

  get showLearnMoreSelectList () {
    return this.$route.params.subpage === SubPageSelectList;
  }

  get toLearnMoreSelectList (): Location {
    return {
      name: this.routeName,
      params: {
        subpage: SubPageSelectList
      }
    };
  }

  get toChoiceOptionFundsList (): Location {
    return {
      name: RouteNames.DrivewealthChoiceOptionFundsList
    };
  }

  get fundItems () {
    if (!this.isLoaded) {
      return [];
    }

    if (this.riskToleranceQuestionnaireStore.userRtqEligibilityResponse.curatedRtqEnabledByEmployerOrPartner) {
      return this.curatedRtqFundItems;
    } else {
      return this.advisoryFundItems;
    }
  }

  get curatedRtqFundItems () {
    if (!this.drivewealthStore.curatedRtqFunds) {
      return [];
    }

    return this.drivewealthStore.curatedRtqFunds.map(f => ({
      instrument: { symbol: f.stockSymbol, companyName: f.company, website: f.website, imageUrl: f.imageUrl },
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(f.fundType)
    }));
  }

  get advisoryFundItems () {
    if (!this.drivewealthStore.advisoryFunds) {
      return [];
    }

    return this.drivewealthStore.advisoryFunds.map(f => ({
      instrument: { symbol: f.stockSymbol, companyName: f.company, website: f.website, imageUrl: f.imageUrl },
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(f.fundType)
    }));
  }

  get managedFundItems () {
    if (!this.drivewealthStore.managedFunds) {
      return [];
    }

    return this.drivewealthStore.managedFunds.map(f => ({
      instrument: { symbol: f.stockSymbol, companyName: "", website: f.webSite, imageUrl: f.imageUrl },
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(f.fundType)
    }));
  }

  fundFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Investment"
    },
    {
      key: "fund_type",
      label: "Fund Type",
      thClass: "text-center",
      tdClass: "text-center"
    }
  ];
}
